import reducer from "./uiReducers";

export default reducer;
